<template>
  <DataList
    title="Контрагенти"
    resource="sales-clients"
    :columns="columns"
    :get-items-fn="getClients"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as clientsApi from "../../backend/clientsApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Назва", name: "name" },
      { title: "Юридична назва", name: "legalName" },
      { title: "Код ЄДРПОУ", name: "edrpou" },
    ],
  }),
  methods: {
    async getClients(...args) {
      const entities = await clientsApi.getClients(args[0], args[1], args[2], args[3]);

      return entities;
    },
  },
};
</script>